'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';
import { Image } from '@/components/client';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';

interface InviteReceiverBannerProps {
  inviterCode: string;
}

export const InviteReceiverBanner = ({
  inviterCode,
}: InviteReceiverBannerProps) => {
  const { data: inviterName } = useSuspenseQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/home-donation-event-history/member-name'
    ]({
      query: {
        memberCode: inviterCode,
      },
    }),
    select: ({ context }) => context?.name,
  });

  return (
    <section className="z-[3] flex w-full flex-col items-center bg-Gray-black">
      {/* 상단 띠 배너 */}
      <div className="flex w-full items-center justify-center bg-[#c21511] py-12">
        <p className="text-center font-700 text-Gray-white typo-body3">
          여기서만! 12월 친구 초대 특별 혜택
        </p>
      </div>

      {/* 메인 콘텐츠 */}
      <div className="flex w-full flex-col items-center gap-70 px-0 py-40">
        <div className="flex w-full flex-col items-center gap-30">
          <div className="flex w-full flex-col items-center gap-35 px-30">
            <div className="flex w-full flex-col items-center justify-center gap-20">
              <p className="text-center font-700 text-[#ffcf9f] typo-h6">
                {inviterName ? `${inviterName}님이 보낸,` : '친구가 보낸,'}
              </p>
              <div className="flex w-full flex-col items-center text-center text-Gray-white">
                <p className="font-900 typo-h2">최대 135만원!</p>
                <p className="font-900 typo-h3">선물을 확인하세요</p>
              </div>
              <div className="relative aspect-[326/299] w-full max-w-[375px]">
                <Image
                  src={`${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/friend-gift.png`}
                  alt="선물 상자"
                  fill
                  preload
                  sizes="(max-width: 1279px) 100vw, 326px"
                  className="object-contain"
                />
              </div>
              <div className="text-center font-500 text-Gray-white typo-body3">
                <p>초대를 받았다면, 12월 이벤트 기간 내에만</p>
                <p>혜택을 받을 수 있어요.</p>
                <p>지금 가입하고 마감 전에 꼭 받으세요!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
